// extracted by mini-css-extract-plugin
export default {"languages":"LanguageSwitcher_languages__k1E5d"};